// extracted by mini-css-extract-plugin
export default {"root":"FileLog_root__B1cAr","root__board_item":"FileLog_root__board_item__v05iY","root__download":"FileLog_root__download__sviy5","root__file_name":"FileLog_root__file_name__yuf-A"};